import { Component, Injector } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { AlergiaDto, AlergiaServiceProxy, TipoAlergiaEnum, UpdateAlergiaDto } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
import { CreateAlergiaComponent } from './create-alergia/create-alergia.component';
import { EditAlergiaComponent } from './edit-alergia/edit-alergia.component';
import { TipoAlergiaList } from '@shared/model/tipo-alergia-enum.model';

export class PagedAlergiaRequestDto extends PagedRequestDto {
  public substancia: string;
  public tipoAlergia: TipoAlergiaEnum;
}

@Component({
  selector: 'app-default-alergias',
  templateUrl: './default-alergias.component.html',
  styleUrls: ['./default-alergias.component.scss'],
  animations: [appModuleAnimation()]
})

export class DefaultAlergiasComponent extends PagedListingComponentBase<AlergiaDto> {
  protected alergias: AlergiaDto[] = [];
  protected request: PagedAlergiaRequestDto = new PagedAlergiaRequestDto();
  protected tiposAlergias: TipoAlergiaList = new TipoAlergiaList();

  constructor(
    injector: Injector,
    private readonly _alergiaService: AlergiaServiceProxy,
    private _modalService: BsModalService
  ) { super(injector) }

  protected list(request: PagedAlergiaRequestDto, pageNumber: number, finishedCallback: Function): void {
    abp.ui.setBusy();
    request.substancia = this.request.substancia;
    request.tipoAlergia = this.request.tipoAlergia;
    this._alergiaService.getAll(
      request.substancia,
      request.tipoAlergia,
      request.skipCount,
      request.maxResultCount
    ).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.alergias = result.items;
      this.totalItems = result.totalCount;
      this.showPaging(result, pageNumber);
    });
  }

  protected delete(entity: AlergiaDto): void {
    abp.message.confirm(`Deseja mesmo remover a alergia ${entity.substancia}?`, "", (result) => {
      if (result) {
        abp.ui.setBusy();
        this._alergiaService.delete(entity.id).pipe(
          finalize(() => {
            abp.ui.clearBusy();
          })
        ).subscribe(() => {
          abp.notify.success("Alergia removida com sucesso!");
          this.refresh();
        })
      }
    });
  }

  protected create(): void {
    const createModal = this._modalService.show(
      CreateAlergiaComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
      }
    );

    createModal.content.onSave.subscribe(() => {
      abp.notify.success("Alergia cadastrada com sucesso!");
      this.refresh();
    });
  }

  protected edit(entity: AlergiaDto): void {
    const updateModal = this._modalService.show(
      EditAlergiaComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          alergia: UpdateAlergiaDto.fromJS(entity.toJSON())
        }
      }
    );

    updateModal.content.onSave.subscribe(() => {
      abp.notify.success("Alergia atualizada com sucesso!");
      this.refresh();
    });
  }

  protected limparFiltro(): void {
    this.request.substancia = undefined;
    this.request.tipoAlergia = undefined;
    this.refresh();
  }
}
